import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

// Add noindex, nofollow meta tag for non-production environments
if (!environment.production) {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.getElementsByTagName('head')[0].appendChild(meta);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
